import {
    defaultFont
} from "../../../../App/styles";

export const styles = theme => ({
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    status: {
        fontSize: 12
    },

    operationButton : {
        defaultFont,
        height: 25,
        width: 40,
        fontSize: 11,
    },
    btnUpdate: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: theme.spacing.unit,
        marginBottom: 20,
        // marginTop: -5,
        fontSize: 15,
        textTransform: 'none',
    },
    typographyContent:{
        defaultFont,
        maxWidth: 250,
        fontSize: 12,
    }
});
